import { render, staticRenderFns } from "./product-item.vue?vue&type=template&id=75f10935&scoped=true"
import script from "./product-item.vue?vue&type=script&lang=js"
export * from "./product-item.vue?vue&type=script&lang=js"
import style0 from "./product-item.vue?vue&type=style&index=0&id=75f10935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f10935",
  null
  
)

export default component.exports